import { css } from "styled-components"
import { FontStyle } from "../../data/types"

// taken from https://developer.mozilla.org/en-US/docs/Web/CSS/font-family
const GENERIC_FONT_FAMILY_NAMES = [
  "serif",
  "sans-serif",
  "monospace",
  "cursive",
  "fantasy",
  "system-ui",
  "ui-serif",
  "ui-sans-serif",
  "ui-monospace",
  "ui-rounded",
  "math",
  "emoji",
  "fangsong",
]

// all lowercase
const FONT_FAMILY_NO_QUOTES = ["-apple-system", "blinkmacsystemfont", ...GENERIC_FONT_FAMILY_NAMES]

export function getStylesForFontStyle(fontStyle: FontStyle) {
  const { fontFamily, fontSize, lineHeight, fontWeight } = fontStyle

  // adds quotes if needed
  const quotedFontFamily = fontFamily
    .split(",")
    .map((family) => {
      if (FONT_FAMILY_NO_QUOTES.includes(family.toLowerCase())) {
        return family // no quotes
      }
      return `"${family}"`
    })
    .join(",")

  return css`
    font-family: ${quotedFontFamily};
    font-size: ${fontSize}px;
    line-height: ${lineHeight}px;
    font-weight: ${fontWeight};
  `
}
